const PropTypes = require('prop-types');
//@vendors
const React = require('react');
//@components
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
const formHelper = require('../../utilities/formHelper');
//@styles
require('./creditLimitSelection.scss');

class CreditLimitSelection extends React.Component {
    constructor(props) {
        super(props);
        this.buildRadioButton = this.buildRadioButton.bind(this);
        this.buildRadioGroup = this.buildRadioGroup.bind(this);
        this.handleOnContinueModal = this.handleOnContinueModal.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);

        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                approvedAmount: true,
                component_id: 'creditLimitSelection'
            };
        }
        this.state = initialState;
    }

    buildRadioButton(radioOption, index) {
        const { approvedAmount } = this.state;
        const subLabel = radioOption.subLabel && (
            <FormattedText value={radioOption.subLabel}
                className="credit-limit-selection__radio-button-sub-label"
            />
        );
        const message = radioOption.message && approvedAmount && (
            <div className="credit-limit-selection__radio-button-message">
                <OKMessage type="important">
                    <FormattedText value={radioOption.message} />
                </OKMessage>
            </div>
        );
        const label = (
            <div className="credit-limit-selection-radio-button-label">
                <div className="credit-limit-selection-radio-button-primary-label">
                    {radioOption.label}
                </div>
                {subLabel}
                {message}
            </div>
        );

        return (
            <RadioButton
                key={index}
                label={label}
                value={radioOption.value}
                className="block-step__radio credit-limit-selection__radio-button"
                overrideLabel={true}
            />
        );
    }

    buildRadioGroup(radioOptions) {
        return (
            <RadioButtonGroup
                name="selectApprovedCredit"
                idPrefix="selectApprovedCredit"
                selectedValue={this.state.approvedAmount}
                className="block-step__radio-group"
                onChange={this.handleRadioButtonChange}
            >
                {radioOptions}
            </RadioButtonGroup>
        );
    }

    handleOnContinueModal() {
        const { dataReceiver, handleOnRequestContinue } = this.props;
        const { approvedAmount } = this.state;

        dataReceiver(approvedAmount);
        handleOnRequestContinue();
    }

    handleRadioButtonChange(event) {
        event = formHelper.stringToBoolean(event);
        let newState = this.state;
        newState.approvedAmount = event;
        this.setState(newState);
    }

    render() {
        const { approvedAmount } = this.state;
        const {
            creditOptions,
            disableContinue,
            handleOnRequestClose,
            openModal
        } = this.props;

        const radioOptions = creditOptions.map((option, index) => {
            return this.buildRadioButton(option, index);
        });
        const radioGroup = this.buildRadioGroup(radioOptions);

        return (
            <ModalCustom
                extraClass="credit-limit-selection"
                shouldCloseOnOverlayClick={false}
                isOpen={openModal}
                onRequestClose={handleOnRequestClose}
                overlayClassName="credit-limit-selection__modal-overlay"
            >
                <header className="credit-limit-selection__header">
                    <FormattedText
                        value="contractsView-creditLimitConfirmationModalTitle"
                        className="credit-limit-selection__title"
                    />
                </header>
                <section>
                    <FormattedText
                        value="contractsView-creditLimitConfirmationModalDescription"
                        className="credit-limit-selection__message"
                    />
                    {radioGroup}
                </section>
                <footer className="credit-limit-selection__footer">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-6 text-left">
                            <OKButton
                                modifier="link-ghost"
                                onClick={handleOnRequestClose}
                            >
                                <FormattedText value="contractsView-creditLimitConfirmationModalCloseButton" />
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton onClick={this.handleOnContinueModal} disabled={approvedAmount && disableContinue}>
                                <FormattedText value="contractsView-creditLimitConfirmationModalContinueButton" />
                            </OKButton>
                        </div>
                    </div>
                </footer>
            </ModalCustom>
        );
    }
}

CreditLimitSelection.defaultProps = {
    disableContinue: false
}

CreditLimitSelection.propTypes = {
    creditOptions: PropTypes.array,
    dataReceiver: PropTypes.func,
    disableContinue: PropTypes.bool,
    handleOnRequestClose: PropTypes.func,
    handleOnRequestContinue: PropTypes.func,
    openModal: PropTypes.bool,
    values: PropTypes.object
};

module.exports = CreditLimitSelection;